export const STRONG_PASSWORD_REGEX =
  // biome-ignore lint/complexity/noUselessEscapeInRegex: Revert regex due to being malformed
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d])[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/;
export const TWO_FA_TOKEN_REGEX = /^[0-9]{6}$/;
export const URL_REGEX =
  /^((http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*))|(http:\/\/localhost(\.\w+)*(:[0-9]+)?\/?)$/;
export const BACKEND_CONNECTION_REGEX =
  /^https?:\/\/(localhost|[\w-]+)(\.[\w-]+)*(:[0-9]+)?(\/.*)?$/;
export const POSITIVE_DECIMAL_NUMBER_REGEX = /^\d*(\.\d{0,2})?$/;
export const URL_WITH_PROTOCOL_REGEX =
  // biome-ignore lint/complexity/noUselessEscapeInRegex: Revert regex due to escaping unnecessary character
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export const FILENAME_REGEX = /^[a-zA-Z0-9_\-. ]+$/;
